/**
 * Cortes de layout que não são os `SCREENS` do Tailwind, com os valores que o
 * web já usava — a fonte (decisão do dono de 2026-09-14: "o web também roda em
 * celular, então os do web são os confiáveis"). Web, mobile e desktop leem
 * daqui; nenhum valor mudou ao nascer este arquivo.
 */
export const BREAKPOINTS = {
  /** Editor e barras do Plate: abaixo disto, layout de celular. */
  editorCompact: 640,
  /** `useIsMobile` do `@tami/ui`: abaixo disto, layout compacto. */
  compactLayout: 1120,
  /** `ReusableModal`: diálogo a partir disto, folha abaixo. */
  modalDialog: 640,
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS;

/** `(max-width: <px - 1>px)` — "abaixo do corte". */
export function belowQuery(px: number): string {
  return `(max-width: ${px - 1}px)`;
}

/** `(min-width: <px>px)` — "a partir do corte". */
export function fromQuery(px: number): string {
  return `(min-width: ${px}px)`;
}
